function seededRandom(seed) {
    let x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
}

function getSeedFromText(text) {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
        hash = text.charCodeAt(i) + ((hash << 5) - hash);
        hash &= hash;
    }
    return Math.abs(hash);
}

export function getRandomThumbnail(seedText) {
    const seed = getSeedFromText(seedText);
    const rand = seededRandom(seed);
    const number = Math.floor(rand * 10) + 1; 
    return `/thumbnail/thumbnail${number}.png`;
}
